//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class InspectionAnswerType(
  public val rawValue: String,
) {
  FREE_TEXT("FREE_TEXT"),
  ADDRESS("ADDRESS"),
  YES_NO_NA("YES_NO_NA"),
  VESSEL_ID("VESSEL_ID"),
  CALENDAR("CALENDAR"),
  COMPLIANCE_NON_COMPLIANCE_NA("COMPLIANCE_NON_COMPLIANCE_NA"),
  USER_ID("USER_ID"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType =
        EnumType("InspectionAnswerType", listOf("FREE_TEXT", "ADDRESS", "YES_NO_NA", "VESSEL_ID", "CALENDAR", "COMPLIANCE_NON_COMPLIANCE_NA", "USER_ID"))

    /**
     * All [InspectionAnswerType] known at compile time
     */
    public val knownEntries: List<InspectionAnswerType>
      get() = listOf(
        InspectionAnswerType.FREE_TEXT,
        InspectionAnswerType.ADDRESS,
        InspectionAnswerType.YES_NO_NA,
        InspectionAnswerType.VESSEL_ID,
        InspectionAnswerType.CALENDAR,
        InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA,
        InspectionAnswerType.USER_ID)

    /**
     * Returns all [InspectionAnswerType] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<InspectionAnswerType> = knownEntries.toTypedArray()

    /**
     * Returns the [InspectionAnswerType] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): InspectionAnswerType = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
